exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans);", ""]);

// module
exports.push([module.id, "#versions{font-size:14px;color:#848484;padding-top:5px;margin-bottom:20px!important}#versions div{margin-bottom:0!important;clear:both}#versions div .version-label{width:230px;float:left;padding-right:5px;clear:none;padding-bottom:7px;color:#717171;font-weight:600;font-size:15px!important}#versions div .number{width:220px;float:left;padding-bottom:7px;clear:none;font-size:14px!important}#credits{font-size:12px}.citation-title{margin-bottom:0!important;margin-top:5px!important;font-size:12px;color:#717171;font-weight:600;clear:both}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1d7d4b50","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/app/components/partials/HelpMenu.vue
// module id = 422
// module chunks = 0